import React from 'react';

import { Cards, CountryPicker, Chart, Geo } from './components';
import { fetchData, fetchDataJp } from './api';
// import styles from './App.module.css';
import { Link } from 'react-router-dom';
import ReplyIcon from '@material-ui/icons/Reply';

import image from './static/images/image.png';

class App3 extends React.Component {
	state = {
		data: {},
		country: ''
	};

	async componentDidMount() {
		const data = await fetchData();

		this.setState({ data });
	}

	handleCountryChange = async (country) => {
		const data = await fetchData(country);

		this.setState({ data, country: country });
	};

	render() {
		const { data, country } = this.state;

		return (
			<div>
				<div>
					<Link to={'/'} className="p-3">
						<ReplyIcon className="pb-2" style={{ fontSize: 'x-large', cursor: 'pointer' }} />{' '}
						<span style={{ fontSize: 'large' }}>Back</span>
					</Link>
				</div>
				<div className="covid-container">
					<img className="covid-image" src={image} alt="COVID-19" />
					<Cards data={data} />
					<CountryPicker handleCountryChange={this.handleCountryChange} />
					<Chart data={data} country={country} />
					<Geo />
				</div>
			</div>
		);
	}
}

export default App3;
